import type { FaireProductEntity } from "../../entity_types/product";

export const p_3lgd3djm: FaireProductEntity = {
  token: "p_3lgd3djm",
  type: "product",
  name: "So Happy For You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/3cbb3fd35b332e2a136fe10d878615928cb3cc974c8972d75855f25ab72f1531/1549296180.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8a680a7bdf6108fb19ff0d0f12abbb1939522acb587f3efe88c0ecdf5dc22668/1528385465.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:50.046Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
